import { BuiltinMemberValue } from './BuiltinMemberValue';
export class BuiltinConstantNumberMemberValue extends BuiltinMemberValue {
    constructor(value) {
        super();
        this.value = value;
    }
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitPushInt(node, this.value);
            sb.emitHelper(node, options, sb.helpers.wrapNumber);
        }
    }
}

//# sourceMappingURL=BuiltinConstantNumberMemberValue.js.map
